"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _XMark = _interopRequireDefault(require("@lt/components/icons-react/rebrand/XMark"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CloseButton = (0, _styledComponents["default"])(_XMark["default"]).withConfig({
  displayName: "CloseButton",
  componentId: "sc-1ad1jba-0"
})(["height:24px;position:fixed;right:0;top:0;margin:20px 16px;z-index:101;path{fill:var(--primary-header-color);}"]);
exports.CloseButton = CloseButton;